<template>
  <div style="width: 70px; height: 40px">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 90 60"
      width="90"
      height="60"
      preserveAspectRatio="xMidYMid meet"
      style="
        width: 100%;
        height: 100%;
        transform: translate3d(0px, 0px, 0px);
        content-visibility: visible;
      "
    >
      <defs>
        <clipPath id="_ai_loadingCon">
          <rect width="90" height="60" x="0" y="0"></rect>
        </clipPath>
      </defs>
      <g clip-path="url(#_ai_loadingCon)">
        <g
          id="ai-loadig-left-ball"
          transform="matrix(1,0,0,1,35,30)"
          opacity="1"
          style="display: block"
        >
          <g opacity="1" transform="matrix(1,0,0,1,-8,0)">
            <path
              fill="#5167ef"
              fill-opacity="1"
              d=" M0,-5 C2.759500026702881,-5 5,-2.759500026702881 5,0 C5,2.759500026702881 2.759500026702881,5 0,5 C-2.759500026702881,5 -5,2.759500026702881 -5,0 C-5,-2.759500026702881 -2.759500026702881,-5 0,-5z"
            ></path>
          </g>
        </g>
        <g
          id="ai-loadig-middle-ball"
          transform="matrix(1,0,0,1,50,30)"
          opacity="1"
          style="display: block"
        >
          <g opacity="1" transform="matrix(1,0,0,1,-8,0)">
            <path
              fill="#5167ef"
              fill-opacity="1"
              d=" M0,-5 C2.759500026702881,-5 5,-2.759500026702881 5,0 C5,2.759500026702881 2.759500026702881,5 0,5 C-2.759500026702881,5 -5,2.759500026702881 -5,0 C-5,-2.759500026702881 -2.759500026702881,-5 0,-5z"
            ></path>
          </g>
        </g>
        <g
          id="ai-loadig-right-ball"
          transform="matrix(1,0,0,1,65,30)"
          opacity="1"
          style="display: block"
        >
          <g opacity="1" transform="matrix(1,0,0,1,-8,0)">
            <path
              fill="#5167ef"
              fill-opacity="1"
              d=" M0,-5 C2.759500026702881,-5 5,-2.759500026702881 5,0 C5,2.759500026702881 2.759500026702881,5 0,5 C-2.759500026702881,5 -5,2.759500026702881 -5,0 C-5,-2.759500026702881 -2.759500026702881,-5 0,-5z"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>
    
    <script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
    <style lang="scss" scoped>
#ai-loadig-left-ball {
  animation: LeftToCenter1 2s linear infinite;
}
#ai-loadig-right-ball {
  animation: LeftToCenter2 2s linear infinite;
}

@keyframes LeftToCenter1 {
  0% {
    transform: matrix(1, 0, 0, 1, 15, 30);
  }
  25% {
    transform: matrix(1, 0, 0, 1, 35, 30);
  }
  50% {
    transform: matrix(1, 0, 0, 1, 38, 30);
  }
  75% {
    transform: matrix(1, 0, 0, 1, 35, 30);
  }
  100% {
    transform: matrix(1, 0, 0, 1, 15, 30);
  }
}
@keyframes LeftToCenter2 {
  0% {
    transform: matrix(1, 0, 0, 1, 85, 30);
  }
  25% {
    transform: matrix(1, 0, 0, 1, 65, 30);
  }
  50% {
    transform: matrix(1, 0, 0, 1, 62, 30);
  }
  75% {
    transform: matrix(1, 0, 0, 1, 65, 30);
  }
  100% {
    transform: matrix(1, 0, 0, 1, 85, 30);
  }
}
@keyframes middleCenter {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
</style>